import TablaYounet from '../Elementos/TablaYounet';
import React, { useEffect, useState } from 'react';


const Element =()=>{

    const [ tipos, setTipos ] = useState([]);
    const [ marcas, setMarcas ] = useState([]);
    const [ isRender, setRender ] = useState(false);


    const headCellsColumn = [
        { id: 'Tipo', numeric: false, disablePadding: false, label: 'Tipo', show:true, fixed:false, width:220, num:0, align:'left', fontSize:'16px', bolder:false, type:'select1' },
        { id: 'Marca', numeric: false, disablePadding: false, label: 'Marca', show:true, fixed:false, width:220, num:1, align:'left', fontSize:'16px', bolder:false , type:'select1'    },
        { id: 'Modelo', numeric: false, disablePadding: false, label: 'Modelo', show:true, fixed:false, width:300, num:2, align:'left', fontSize:'16px', bolder:false , type:'text'    },
        { id: 'Precio', numeric: false, disablePadding: false, label: 'Precio', show:true, fixed:false, width:200, num:3, align:'left', fontSize:'16px', bolder:false , type:'text'    },
    ];

    const variablesObject = {
        api:'/api/EquiposAls',
        apiMultiples:'/api/EquiposAls/multiple',
        isButtonAdd:true,
        isMultiline:false,
        isUpperCase:false,   
        label:'EQUIPOS',
        nameLocalStorage:'headersEquiposAlmaAC',
        OptionSearch:'Tipo',
        order:'desc',
        orderBy:'Tipo',
        Ruta:'/Almacen/Equipos',
        rowsPerPage:13,
        sumWidth:1100,
        title:'EQUPOS',
        titleColor:'#3b5999',
        titleSizeXL:18,
        titleSizeXS:13,
        widthAction:160,
    };

    useEffect(()=>{
        (async ()=>{
            const apiM = await fetch('/api/marcas');
            const jsnM = await apiM.json();
            setMarcas(jsnM);
            const apiT = await fetch('/api/tipos');
            const jsnT = await apiT.json();
            setTipos(jsnT);
            setRender(true);
        })()
    },[])

    return (
        isRender?
(        <TablaYounet
            headCellsColumn={headCellsColumn}
            variablesObject={variablesObject}
            tipos={tipos}
            marcas={marcas}
        />):null
    )
}

export default Element;